import { connect } from 'react-redux';

import { Creators as GrowlActions } from 'Reducers/growl';
import { Creators as transientActions } from 'Reducers/transient';
import { Creators as adminActions } from 'Reducers/adminOnboarding';

import BulkReleaseBlock from './view';

export default connect(
  state => ({
    adminOnboarding: state.adminOnboarding,
    transient: state.transient
  }),
  {
    getCampaignsByClient: adminActions.getCampaignsByClient,
    getClients: adminActions.getClients,
    getSigners: adminActions.getSigners,
    releaseBlock: adminActions.releaseBlock,
    updateGrowlProps: GrowlActions.updateProps,
    updateTransientProps: transientActions.updateProps
  }
)(BulkReleaseBlock);
